export default __webpack_public_path__ + "static/media/GymTonicMuscleStrength.a4019a55.png";